export default "__VITE_ASSET__C19gSPvf__"